export const affirmationCards = [
  {
    id: 1,
    affirmation: "I am not what happened to me. I am what I choose to become through Christ.",
    scripture: "Therefore, if anyone is in Christ, the new creation has come: the old has gone, the new is here!",
    reference: "2 Corinthians 5:17"
  },
  {
    id: 2,
    affirmation: "My body is a temple of the Holy Spirit. What was done to it does not define its worth.",
    scripture: "Do you not know that your bodies are temples of the Holy Spirit, who is in you?",
    reference: "1 Corinthians 6:19"
  },
  {
    id: 3,
    affirmation: "I release the shame that was never mine to carry. I walk in God's grace today.",
    scripture: "There is now no condemnation for those who are in Christ Jesus.",
    reference: "Romans 8:1"
  },
  {
    id: 4,
    affirmation: "God is close to me in my brokenness. He collects every tear I have cried.",
    scripture: "The Lord is close to the brokenhearted and saves those who are crushed in spirit.",
    reference: "Psalm 34:18"
  },
  {
    id: 5,
    affirmation: "I am worthy of love, safety, and tenderness. My past does not disqualify me from blessing.",
    scripture: "See what great love the Father has lavished on us, that we should be called children of God!",
    reference: "1 John 3:1"
  },
  {
    id: 6,
    affirmation: "My healing is not linear, but every step forward is seen and celebrated by God.",
    scripture: "He who began a good work in you will carry it on to completion.",
    reference: "Philippians 1:6"
  },
  {
    id: 7,
    affirmation: "I give myself permission to grieve what was taken from me and to hope for what is ahead.",
    scripture: "He will wipe every tear from their eyes. There will be no more death or mourning or crying or pain.",
    reference: "Revelation 21:4"
  },
  {
    id: 8,
    affirmation: "I am not too broken for God to use. My scars are proof of His healing power.",
    scripture: "But he said to me, 'My grace is sufficient for you, for my power is made perfect in weakness.'",
    reference: "2 Corinthians 12:9"
  },
  {
    id: 9,
    affirmation: "I choose to break the silence. My voice matters. My story has purpose.",
    scripture: "For God has not given us a spirit of fear, but of power and of love and of a sound mind.",
    reference: "2 Timothy 1:7"
  },
  {
    id: 10,
    affirmation: "Today I choose to trust again, even if it is just one small step at a time.",
    scripture: "Trust in the Lord with all your heart and lean not on your own understanding.",
    reference: "Proverbs 3:5"
  },
  {
    id: 11,
    affirmation: "I am allowed to set boundaries. Protecting my peace is an act of wisdom, not selfishness.",
    scripture: "Above all else, guard your heart, for everything you do flows from it.",
    reference: "Proverbs 4:23"
  },
  {
    id: 12,
    affirmation: "The enemy meant to destroy me, but God is turning my pain into my greatest testimony.",
    scripture: "You intended to harm me, but God intended it for good.",
    reference: "Genesis 50:20"
  },
  {
    id: 13,
    affirmation: "I am no longer a victim. I am an overcomer, rewritten by grace.",
    scripture: "No, in all these things we are more than conquerors through him who loved us.",
    reference: "Romans 8:37"
  },
  {
    id: 14,
    affirmation: "I forgive not because what happened was okay, but because I deserve to be free.",
    scripture: "It is for freedom that Christ has set us free. Stand firm, then, and do not let yourselves be burdened again by a yoke of slavery.",
    reference: "Galatians 5:1"
  },
  {
    id: 15,
    affirmation: "My inner child deserves gentleness. I choose to nurture and protect her today.",
    scripture: "He tends his flock like a shepherd: He gathers the lambs in his arms and carries them close to his heart.",
    reference: "Isaiah 40:11"
  },
  {
    id: 16,
    affirmation: "I am being rebuilt from the inside out. God wastes nothing in my story.",
    scripture: "And we know that in all things God works for the good of those who love him.",
    reference: "Romans 8:28"
  },
  {
    id: 17,
    affirmation: "I am safe in God's presence. He is my refuge when the world feels overwhelming.",
    scripture: "God is our refuge and strength, an ever-present help in trouble.",
    reference: "Psalm 46:1"
  },
  {
    id: 18,
    affirmation: "I have survived the storm. Now I will learn to dance in the rain of God's renewal.",
    scripture: "He has sent me to bind up the brokenhearted, to proclaim freedom for the captives.",
    reference: "Isaiah 61:1"
  },
  {
    id: 19,
    affirmation: "My breakthrough is not a one-time event. It is a daily decision to walk in freedom.",
    scripture: "The righteous will flourish like a palm tree, they will grow like a cedar of Lebanon.",
    reference: "Psalm 92:12"
  },
  {
    id: 20,
    affirmation: "I am fearfully and wonderfully made. No abuse, no trauma, no lie can undo what God has declared.",
    scripture: "I praise you because I am fearfully and wonderfully made; your works are wonderful.",
    reference: "Psalm 139:14"
  }
];

export const decisionCards = [
  {
    id: 1,
    title: "The Crossroads of Fear & Faith",
    prompt: "When fear tells me to stay still, what is faith inviting me to step into?",
    prayer: "Lord, help me see the open door when fear only shows me walls. Give me courage to move forward even when I cannot see the full path.",
    scripture: "For I know the plans I have for you, declares the Lord, plans to prosper you and not to harm you.",
    reference: "Jeremiah 29:11"
  },
  {
    id: 2,
    title: "Choosing Your Circle",
    prompt: "Am I surrounded by people who water my growth or drain my healing?",
    prayer: "Father, give me discernment to recognise who belongs in this season of my life. Help me release toxic ties with grace and draw near to those who reflect Your love.",
    scripture: "Walk with the wise and become wise, for a companion of fools suffers harm.",
    reference: "Proverbs 13:20"
  },
  {
    id: 3,
    title: "When Forgiveness Feels Impossible",
    prompt: "What am I holding onto that is hurting me more than the person who caused the pain?",
    prayer: "God, I cannot do this alone. Help me begin the process of releasing this burden. I do not condone what was done, but I choose freedom over bitterness.",
    scripture: "Bear with each other and forgive one another if any of you has a grievance against someone.",
    reference: "Colossians 3:13"
  },
  {
    id: 4,
    title: "Boundaries as Holy Ground",
    prompt: "Where do I need to draw a line to protect the peace God is restoring in me?",
    prayer: "Lord, give me the strength to say no without guilt. Let my boundaries be an act of obedience to You, not rebellion against others.",
    scripture: "Above all else, guard your heart, for everything you do flows from it.",
    reference: "Proverbs 4:23"
  },
  {
    id: 5,
    title: "Stepping Into Purpose",
    prompt: "What would I pursue if I believed God has already qualified me?",
    prayer: "Father, silence the voice that says I am not enough. You have equipped me for this moment. Help me step into the calling You placed on my life before I was formed.",
    scripture: "Before I formed you in the womb I knew you, before you were born I set you apart.",
    reference: "Jeremiah 1:5"
  },
  {
    id: 6,
    title: "Healing vs. Hiding",
    prompt: "Am I truly healing, or am I just getting better at hiding my pain?",
    prayer: "Lord, I do not want to perform wellness. I want to experience it. Meet me in the places I have been avoiding. I trust You with my rawest truth.",
    scripture: "Then you will know the truth, and the truth will set you free.",
    reference: "John 8:32"
  },
  {
    id: 7,
    title: "The Financial Leap",
    prompt: "Is financial fear stopping me from investing in my healing or my calling?",
    prayer: "God, You are my provider. Help me steward what You have given me wisely and trust You with what I cannot yet see. Open doors of provision I have not imagined.",
    scripture: "And my God will meet all your needs according to the riches of his glory in Christ Jesus.",
    reference: "Philippians 4:19"
  },
  {
    id: 8,
    title: "Letting Go of Control",
    prompt: "What area of my life am I gripping too tightly because I am afraid of being hurt again?",
    prayer: "Father, I surrender my need to control every outcome. I trust that Your hands are safer than my own. Help me release and receive Your plan.",
    scripture: "Commit your way to the Lord; trust in him and he will act.",
    reference: "Psalm 37:5"
  },
  {
    id: 9,
    title: "Speaking Up or Staying Silent",
    prompt: "Is my silence protecting me, or is it protecting the person who hurt me?",
    prayer: "Lord, give me the words and the moment. Help me speak my truth with grace and power. Let my voice be an instrument of healing, not just for me, but for others.",
    scripture: "Speak up for those who cannot speak for themselves, for the rights of all who are destitute.",
    reference: "Proverbs 31:8-9"
  },
  {
    id: 10,
    title: "Rest Without Guilt",
    prompt: "When did I start believing that rest was laziness instead of obedience?",
    prayer: "God, You rested on the seventh day. Teach me that slowing down is not failing. My worth is not in my productivity but in Your love for me.",
    scripture: "Come to me, all you who are weary and burdened, and I will give you rest.",
    reference: "Matthew 11:28"
  },
  {
    id: 11,
    title: "Breaking Generational Patterns",
    prompt: "What cycle am I willing to end with me so my children can begin a new story?",
    prayer: "Father, I declare that the pain stops here. What was passed down to me will not be passed down through me. Empower me to break every chain in Your name.",
    scripture: "He has sent me to bind up the brokenhearted, to proclaim freedom for the captives.",
    reference: "Isaiah 61:1"
  },
  {
    id: 12,
    title: "Trusting God With the Outcome",
    prompt: "If I gave God full control of this situation, what would change about how I feel right now?",
    prayer: "Lord, I lay this decision at Your feet. I do not need to know the ending to trust the Author. Write my next chapter with Your unfailing love.",
    scripture: "Trust in the Lord with all your heart and lean not on your own understanding.",
    reference: "Proverbs 3:5-6"
  }
];

export const fearVsTruthCards = [
  {
    id: 1,
    fear: "I am damaged beyond repair. No one could ever truly love me.",
    truth: "You are God's masterpiece, created anew in Christ Jesus to do the good things He planned for you long ago.",
    reference: "Ephesians 2:10"
  },
  {
    id: 2,
    fear: "It was my fault. I should have done something to stop it.",
    truth: "The Lord is a refuge for the oppressed, a stronghold in times of trouble. He does not hold the abused responsible for their abuser's sin.",
    reference: "Psalm 9:9"
  },
  {
    id: 3,
    fear: "God let this happen to me. He does not care about my pain.",
    truth: "The Lord is close to the brokenhearted and saves those who are crushed in spirit. He has kept count of every tear.",
    reference: "Psalm 34:18"
  },
  {
    id: 4,
    fear: "I will never feel safe in my own body again.",
    truth: "Do you not know that your body is a temple of the Holy Spirit? You were bought at a price. God's Spirit dwells in you and guards you.",
    reference: "1 Corinthians 6:19-20"
  },
  {
    id: 5,
    fear: "If people knew the real me, they would leave.",
    truth: "Nothing can separate you from the love of God. Not your past, not your pain, not the darkest thing you carry.",
    reference: "Romans 8:38-39"
  },
  {
    id: 6,
    fear: "I am too broken to be used by God.",
    truth: "My grace is sufficient for you, for my power is made perfect in weakness. Your cracks are where His light shines through.",
    reference: "2 Corinthians 12:9"
  },
  {
    id: 7,
    fear: "I will never be able to trust anyone again.",
    truth: "The Lord himself goes before you and will be with you. He will never leave you nor forsake you. Do not be afraid.",
    reference: "Deuteronomy 31:8"
  },
  {
    id: 8,
    fear: "My future has been stolen. There is nothing good left for me.",
    truth: "I will repay you for the years the locusts have eaten. You will have plenty to eat until you are full, and you will praise the name of the Lord your God.",
    reference: "Joel 2:25-26"
  },
  {
    id: 9,
    fear: "I do not deserve to heal. Other people had it worse.",
    truth: "He heals ALL the brokenhearted and binds up their wounds. There is no ranking in His healing room. Your pain is valid.",
    reference: "Psalm 147:3"
  },
  {
    id: 10,
    fear: "I am alone in this. Nobody truly understands what I have been through.",
    truth: "He was despised and rejected by mankind, a man of suffering and familiar with pain. Jesus walks with you because He knows suffering intimately.",
    reference: "Isaiah 53:3"
  },
  {
    id: 11,
    fear: "I will pass this trauma onto my children. The cycle cannot be broken.",
    truth: "He has sent me to bind up the brokenhearted, to proclaim freedom for the captives. The cycle ends here, in His name.",
    reference: "Isaiah 61:1"
  },
  {
    id: 12,
    fear: "Forgiveness means what happened was okay. I cannot do that.",
    truth: "It is for freedom that Christ has set us free. Forgiveness is not approval. It is your liberation from carrying their weight.",
    reference: "Galatians 5:1"
  },
  {
    id: 13,
    fear: "I am defined by what was done to me. That is all people see.",
    truth: "Therefore, if anyone is in Christ, the new creation has come. The old has gone, the new is here. You are redefined by grace.",
    reference: "2 Corinthians 5:17"
  },
  {
    id: 14,
    fear: "God is punishing me. I must have done something to deserve this.",
    truth: "The Lord is gracious and compassionate, slow to anger and rich in love. This was never your punishment. This was never His plan for you.",
    reference: "Psalm 145:8"
  },
  {
    id: 15,
    fear: "I will never experience true joy or peace again.",
    truth: "Weeping may stay for the night, but rejoicing comes in the morning. Your season of mourning has an expiration date. Joy is coming.",
    reference: "Psalm 30:5"
  }
];

export const GUMROAD_LINKS = {
  affirmation: "https://mcgowancee.gumroad.com/l/dyhvd",
  decision: "https://mcgowancee.gumroad.com/l/hreac",
  fearVsTruth: "https://mcgowancee.gumroad.com/l/giarwo",
  bundle: "https://mcgowancee.gumroad.com/l/yoitf"
};
